import type { ResearchSessionStatus } from "@globals";

/** Non-terminal runs: shown in the chat status bar (DeepResearchChatStatus), which carries the
 * cancel action, and counted by the Research nav gate (hasResearchNavContent). Terminal runs
 * have no session surface — a succeeded one is represented by its report, and a failed or
 * cancelled one is currently not shown anywhere. */
export const ACTIVE_RESEARCH_STATUSES: ResearchSessionStatus[] = ["PENDING", "RUNNING"];
